import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import theme from '@ep/theme';

const FooterLink = styled(Link)`
  margin-bottom: 0.625rem;
  font-family: ${theme.typography.footerFont};
  font-size: ${theme.typography.toRem(13)};
  line-height: ${theme.typography.toRem(16)};
  color: ${theme.colors.white};
`;

export default FooterLink;
